<template>
  <div>
    <div v-if="!surveys.length">
      <b-alert show variant="warning">
        No Surveys
      </b-alert>
    </div>
    <table class="table table-striped" v-if="surveys.length">
      <thead>
        <tr>
          <th>Name</th>
          <th>Shown</th>
          <th>Date Added</th>
          <th>Date Updated</th>
          <th>Created By</th>
          <th class="action-single"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in surveys" :key="item._id">
          <td>
            <i class="fa fa-eye mr-2" v-if="item.enabled===true"></i>
            <i class="fa fa-eye-slash mr-2" v-if="item.enabled===false || item.enabled===undefined"></i>
            <router-link :to="{name: 'ManageSurvey', params: {id: item._id}}">{{item.name}}</router-link>
          </td>
          <td>{{shown(item)}}</td>
          <td>
            {{item.dateAdded | formatDate}}
          </td>
          <td>
            {{item.dateUpdated | formatDate}}
          </td>
          <td>
            <div v-if="item.user">
              {{item.user.firstName}} {{item.user.lastName}}
            </div>
          </td>
          <td><button class="btn btn-sm btn-danger" @click="deleteItem(item)"><i class="fa fa-remove"></i> Delete</button></td>
        </tr>
      </tbody>
    </table>
    <b-modal title="Confirm Delete" class="modal-danger" v-model="deleteModal" @ok="confirmDelete()" ok-variant="danger">
      <div><b>Are you sure you want to delete this survey?</b></div>
      <div>{{selectedItem.name}}</div>
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios';
import common from './../../mixins/common'

export default {
  name: 'surveylist',
  data () {
    return {
      selectedItem: {},
      deleteModal: false
    }
  },
  props: ['surveys','emptyMessage'],
  mixins: [common],
  methods: {
    deleteItem: function (selItem) {
      this.selectedItem = selItem;
      this.deleteModal = true;
    },
    confirmDelete: function () {
      this.deleteModal = false;
      let scope = this;
      axios.delete(process.env.VUE_APP_API + '/survey/' + scope.selectedItem._id, {
        headers: {
          Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
          }
        })
          .then(function (response) {
            scope.$emit('getItems');
          })
          .catch(function (error) {
            console.log(error);
          });
    }
  }
}
</script>
